import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './api'; // configure axios auth (token + 401 redirect) app-wide
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 